import { PropsWithChildren } from "react";
import { PageGrid, PageGridProps } from "src/components/layout/page-grid/deprecated/PageGrid";

/**
 * PageGrid used to structure the content area of a page in the EKP.
 */
export const EKPPageGrid = (props: PropsWithChildren<PageGridProps>) => {
    return (
        <PageGrid
            columns={{ xsMobile: 4, sm: 8, md: 12 }}
            columnSpacing={{ xsMobile: 2, sm: 3 }}
            px={{ xsMobile: 2, sm: 3, md: 10 }}
            maxContentWidth={"1440px"}
            my={0}
            {...props}
        />
    );
};
